import React from 'react';
import { getFlag } from '../../../config/flags';
import Modal from '../../generic/Modal';
import ConfigModalHeader from './ConfigModalHeader';
import ConfigPanelBody from './ConfigPanelBody';
import ConfigPanelFooter from './ConfigPanelFooter';

const ConfigLayoutWrapper = ({ renderHeader, renderBody, renderFooter, title, elementType, onHide, container, className }) => (
    getFlag('canvas') ? (
        // Modal view (new canvas)
        <Modal
            renderHeader={() => (
                <ConfigModalHeader
                    title={title}
                    elementType={elementType}
                />
            )}
            renderBody={renderBody}
            renderFooter={renderFooter}
            onHide={onHide}
            dialogClassName="modal-large config-modal"
            container={container}
        />
    ) : (
        // Sidebar view (old canvas)
        <div className="flex flex-column full-height">
            <ConfigPanelBody className={className}>
                {renderHeader()}

                {renderBody()}
            </ConfigPanelBody>
            <ConfigPanelFooter>
                {renderFooter()}
            </ConfigPanelFooter>
        </div>
    )
);

export default ConfigLayoutWrapper;
